import {ERROR_COLOR, GREY_INFO_COLOR, SUCCESS_COLOR} from "../../../../../../../themes/themeConfigurator";

const styles = () => ({
  typeLabel: {
    color: GREY_INFO_COLOR,
    textTransform: 'uppercase',
    fontSize: 12,
  },
  subCategoryName: {
    fontSize: 16,
  },
  assetName: {
    fontSize: 12,
    color: GREY_INFO_COLOR,
  },
  red: {
    color: ERROR_COLOR,
  },
  green: {
    color: SUCCESS_COLOR,
  }
});

export default styles;